import { action } from 'typesafe-actions';
import { BankSelectionActionTypes as act } from './actionTypes';

export function selectBank(selectedBank) {
  return action(act.SELECT_BANK, { selectedBank });
}
